/** Phân quyền — khách hàng */
export const KHACH_HANG_PERMISSION_CODES = {
  WEB_BH_KHACH_HANG_LIST: 'WEB_BH_KHACH_HANG_LIST',
  WEB_BH_KHACH_HANG_ADD: 'WEB_BH_KHACH_HANG_ADD',
  WEB_BH_KHACH_HANG_EDIT: 'WEB_BH_KHACH_HANG_EDIT',
  WEB_BH_KHACH_HANG_DELETE: 'WEB_BH_KHACH_HANG_DELETE',
  WEB_BH_KHACH_HANG_TOGGLE_STATUS: 'WEB_BH_KHACH_HANG_TOGGLE_STATUS',
  WEB_BH_KHACH_HANG_IMPORT: 'WEB_BH_KHACH_HANG_IMPORT',
  WEB_BH_KHACH_HANG_EXPORT: 'WEB_BH_KHACH_HANG_EXPORT',
} as const

export type KhachHangPermissionCode = (typeof KHACH_HANG_PERMISSION_CODES)[keyof typeof KHACH_HANG_PERMISSION_CODES]

export const KHACH_HANG_MUTATE_PERMISSIONS = [
  KHACH_HANG_PERMISSION_CODES.WEB_BH_KHACH_HANG_ADD,
  KHACH_HANG_PERMISSION_CODES.WEB_BH_KHACH_HANG_EDIT,
  KHACH_HANG_PERMISSION_CODES.WEB_BH_KHACH_HANG_DELETE,
  KHACH_HANG_PERMISSION_CODES.WEB_BH_KHACH_HANG_TOGGLE_STATUS,
  KHACH_HANG_PERMISSION_CODES.WEB_BH_KHACH_HANG_IMPORT,
] as const
